import { render, staticRenderFns } from "./DoctorStatus.vue?vue&type=template&id=0d883d15&scoped=true"
import script from "./DoctorStatus.vue?vue&type=script&lang=js"
export * from "./DoctorStatus.vue?vue&type=script&lang=js"
import style0 from "./DoctorStatus.vue?vue&type=style&index=0&id=0d883d15&prod&scoped=true&lang=css"
import style1 from "./DoctorStatus.vue?vue&type=style&index=1&id=0d883d15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d883d15",
  null
  
)

export default component.exports